// @ts-nocheck
import { Box, Stack } from "@smoothie-framework/ui";

export const asset = (name: string): string => `/assets/zequels/${name}`;
const observedAnimatedImages = new WeakSet<HTMLImageElement>();

export const Icon = ({ children }: { children: string }) => (
  <span aria-hidden="true" className="icon">
    {children}
  </span>
);

export const AnimatedSvgImage = ({
  alt,
  height,
  image,
  width,
}: {
  alt: string;
  height: number;
  image: string;
  width: number;
}) => (
  <img
    alt={alt}
    height={height}
    ref={(element: unknown) => {
      if (!(element instanceof HTMLImageElement) || observedAnimatedImages.has(element)) {
        return;
      }

      observedAnimatedImages.add(element);
      let observer: IntersectionObserver | undefined;

      const playAnimation = () => {
        element.src = asset(image);
        observer?.disconnect();
      };

      if ("IntersectionObserver" in window) {
        observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              playAnimation();
            }
          },
          { threshold: 0.5 },
        );

        observer.observe(element);
        return;
      }

      playAnimation();
    }}
    src={asset(image.replace(".svg", "-initial.svg"))}
    width={width}
  />
);

export const Gutter = ({
  children,
  className = "",
  ...props
}: {
  children: any;
  className?: string;
  [key: string]: unknown;
}) => (
  <Stack
    {...props}
    className={`page-gutter ${className}`}
    w="full"
    maxW={360}
    mx="auto"
    px={{ base: 6, md: 16 }}
  >
    {children}
  </Stack>
);

export const WorkflowImage = ({
  className,
  image,
  alt,
}: {
  className?: string;
  image: string;
  alt: string;
}) => (
  <Box
    className={`preview ${className ?? ""}`}
    overflow="hidden"
    rounded="xl"
    shadow="lg"
    w="full"
  >
    <AnimatedSvgImage
      alt={alt}
      height={420}
      image={image}
      width={796}
    />
  </Box>
);
